var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-chart"},[_c('app-echart-gradient-line',{attrs:{"optionData":_vm.option,"line":_vm.lineData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }